import React from 'react'
import styled from 'styled-components'
import { BreakingWidth } from './var'

const StyledContent = styled.div`
  width: 100vw;
  .content {
    /* max-width: ${BreakingWidth.xl}; */
    /* margin: 0 auto; */
    margin: 20px;
    padding: 20px 35px;
    background-color: #fff;

    &::before {
      content: '';
      height: 40vh;
      width: 100vw;
      background-color: #f9bb19;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      z-index: -1;
    }
  }

  @media screen and (max-width: 600px) {
    .content {
      padding: 10px;
      margin: 10px;
    }
  }
`

export const Content: React.FC = (props) => (
  <StyledContent>
    <div className="content">{props.children}</div>
  </StyledContent>
)
